<template>
  <session-content-container :title="title">
    <template #right>
      <ag-confirm-dialog
        :title="$t('general.confirmation')"
        :message="$t('animation.ontime.nextQuestion.message')"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.validate')"
        validation-btn-color="accent"
        @confirm="goToQuestionTwo"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingNextQuestion"
            :disabled="loadingNextQuestion || hasNoPlayerOnFirstQuestion"
            small
            color="accent"
            v-bind="attrs"
            v-on="on"
            v-text="$t('animation.ontime.nextQuestion.button')"
          />
        </template>
      </ag-confirm-dialog>
    </template>
    <template v-if="game">
      <v-row no-gutters>
        <v-col
          v-for="player in game.playerList"
          :key="player.id"
          class="pa-2 d-flex flex-column"
          cols="12"
          lg="4"
          xl="3"
        >
          <player-card
            :value="player"
            class="flex-grow-1"
            :number-of-instructions="game.numberOfInstructions"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <bar-chart-card :game="game" />
        </v-col>
      </v-row>
    </template>
  </session-content-container>
</template>

<script>
import { mapActions } from 'vuex'
import _throttle from 'lodash/throttle'
import Repositories from 'src/repositories'

import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import SessionContentContainer from '../SessionContentContainer'
import PlayerCard from '../../components/on-time/PlayerCard'
import BarChartCard from '../../components/on-time/BarChartCard'

export default {
  name: 'OnTimeContainer',
  components: {
    AgConfirmDialog,
    SessionContentContainer,
    PlayerCard,
    BarChartCard,
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    gameId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    game: null,
    loading: false,
    loadingNextQuestion: false,
  }),
  computed: {
    title () {
      if (this.loading) {
        return this.$t('general.loading')
      }
      return this.$t('animation.menu.games.onTime')
    },
    hasNoPlayerOnFirstQuestion () {
      return this.game?.playerList
        .every(player => ['canAnswerQuestionTwo', 'finished'].includes(player.status))
    },
  },
  sockets: {
    trainingSessionPlayerLoggedIn ({ idSession }) {
      if (this.sessionId === idSession) {
        this.fetchData()
      }
    },
    onTimeSessionPlayerAnsweredQuestionOne ({ onTimeSessionId }) {
      if (this.gameId === onTimeSessionId) {
        this.fetchData()
      }
    },
    onTimeSessionPlayerAnsweredQuestionTwo ({ onTimeSessionId }) {
      if (this.gameId === onTimeSessionId) {
        this.fetchData()
      }
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.fetchData()
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showErrorNotification: 'showErrorNotification',
    }),
    fetchData: _throttle(async function fetchData () {
      this.game = await Repositories.animation.ontime.get(this.gameId)
      // Show message only during the first load (not on data refresh)
      this.loading = false
    }, 200, { leading: true, trailing: true }),
    async goToQuestionTwo () {
      this.loadingNextQuestion = true
      try {
        await Repositories.animation.ontime.sendAction({
          gameId: this.gameId,
          actionName: 'goToQuestionTwo',
        })
        this.fetchData()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
        console.error(error)
      }
      finally {
        this.loadingNextQuestion = false
      }
    },
  },
}
</script>
